
import React, { useState, useEffect } from "react";
import AuthService from "../controllers/AuthService";

const HeaderText = props => {

    const [userFullName, setUserFullName] = useState([]);

    useEffect(() => {
        const name = AuthService.getUserFullName();
        setUserFullName(name);
    })

    return (

        <div className="text-center py-2">
            <h1 className="m-0">{props.text1}</h1>
            <h3 className="font-sarabun font-weight-600">{userFullName}</h3>
        </div>


    )
}

export default HeaderText